// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3fueM","legacyBtn":"MutateMid_legacyBtn__16h6k"};